module.exports = __webpack_public_path__ + "static/media/lou160px.2f799188.jpg";